<template>
  <div class="win-cooperation" :style="{height: clientHeight + 'px'}">
    <nav-bar @anchorJump="anchorJump" :main-index="2"></nav-bar>
    <section class="part-one">
      <div style="width: 800px">
        <h1>合作共赢</h1>
        <article>
          <p>我们为众多的合作伙伴和客户在全球金融市场交易上提供革新技术，用户可以专注于其核心业务，一起推动开放共赢</p>
        </article>
        <h4>直道而行，达至天下</h4>
      </div>
    </section>
    <section class="part-bottom">
      <div>
        <p>
          基于公司雄厚的经济实力、完善的团队人员管理、深耕多年的交易解决方案，我们为客户提供
          <span>白标方案即OEM方案</span>，搭建自己专属的商标和品牌
        </p>
        <dt>我们为您提供：</dt>
        <dl class="wow slideInUp" data-wow-duration="1000ms" offset="0">
          <dd>直接交易市场接入（DMA）</dd>
          <dd>期货证券一站式交易平台</dd>
          <dd>客户及后台管理系统</dd>
          <dd>快速并且稳定的网络</dd>
          <dd>专业的技术支持</dd>
        </dl>
      </div>
    </section>
  </div>
</template>

<script>
import navBar from "../components/navBar";
export default {
  name: "winCooperation",
  components: {
    navBar: navBar
  },
  data() {
    return {
      clientHeight: document.documentElement.clientHeight
    };
  },
  mounted() {
    this.$nextTick(() => {
      new this.$wow.WOW().init();
    });
  },
  created() {},
  methods: {
    anchorJump(index) {
      this.subnav = index;
      this.$nextTick(() => {
        this.windowScroll();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.win-cooperation {
  width: 100%;
  box-sizing: border-box;
  background: url("../assets/images/winCooperationBg.png") center 78px no-repeat;
  background-size: 100%;
  overflow: hidden;

  .part-one {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    padding-right: 126px;
    padding-top: 178px;
    h1 {
      font-size: 60px;
      font-weight: bold;
      color: #ffa63e;
      line-height: 70px;
      padding-bottom: 20px;
    }
    p {
      width: 781px;
      font-size: 30px;
      line-height: 48px;
      padding-bottom: 30px;
    }
    h4 {
      font-size: 20px;
      line-height: 36px;
      text-align: right;
      padding-right: 25px;
    }
  }

  .part-bottom {
    width: 100%;
    height: 300px;
    background: #1f293b;
    opacity: 0.9;
    position: absolute;
    bottom: 0;
    padding-top: 30px;
    box-sizing: border-box;
    text-align: center;
    dt {
      font-size: 24px;
      line-height: 70px;
      width: 820px;
      margin: 0 auto;
      text-align: left;
    }
    p {
      width: 1000px;
      font-size: 24px;
      padding-bottom: 25px;
      margin: 0 auto;
      color: #ffffff;
      line-height: 36px;
      text-align: left;
      span {
        font-size: 30px;
        color: #ffa63e;
      }
    }
    dl {
      text-align: center;
      display: inline-block;
      zoom: 1;
      width: 825px;
      dd {
        width: 33.33333%;
        font-size: 16px;
        line-height: 36px;
        float: left;
        position: relative;
        padding-left: 30px;
        box-sizing: border-box;
        text-align: left;

        &::before {
          content: "";
          position: absolute;
          border-radius: 50%;
          display: block;
          top: 12px;
          left: 5px;
          width: 11px;
          height: 11px;
          background: #00a0e9;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/winCooperation.vue